import React from 'react';
import CheckBox from 'grommet/components/CheckBox';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Anchor from 'grommet/components/Anchor';
import LineChartIcon from 'grommet/components/icons/base/LineChart';


const names = ["Label 1", "Label 2", "Label 3"]

const colorPrim = ["rgb(91,100,114)", "rgba(91, 100, 114, 0.25)", "rgb(86,130,216)"];
const colorPrim2 = ["rgb(86,130,216)", "rgba(91, 100, 114, 0.25)", "rgb(91,100,114)"];

class BarSample extends React.Component {
    constructor() {
        super();
        this.state = { 
            rotate: true,
            stack: true,
            legends: true
             }
        this._onClick = this._onClick.bind(this);
    }
    _onClick(output) {

        this.props.onSubmit(output)
    }
    _onChange(event) {

        let { rotate,stack,legends } = this.state
        switch(event) {
            case "rotate":
                this.setState({ rotate: !rotate })
                break;
            case "stack":
                this.setState({ stack: !stack })
                break;
            case "legends":
                this.setState({ legends: !legends })
                break;
        }
    }
    render() {
        const {rotate, stack, legends} = this.state
        const output = {rotate, stack, legends};
        return (
            <div>
            <h2><strong>Chose Options</strong></h2>
                 <Box direction='row'
                    justify='center'
                    align='center'
                    wrap={true}
                    reverse={false}
                    margin='none'
                    >
                    
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        >    
                            <CheckBox 
                            name='rotate'
                            id='rotate'
                            label='Rotate'
                            toggle={true}
                            disabled={false}
                            reverse={true}
                            defaultChecked={true}
                            onChange={this._onChange.bind(this, 'rotate')}/>
                    </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        >   
                            <CheckBox 
                            name='stack'
                            id='stack'
                            label='Stack'
                            toggle={true}
                            disabled={false}
                            reverse={true}
                            defaultChecked={true}
                            onChange={this._onChange.bind(this, 'stack')}/>
                    </Box>
                    
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        >   
                        <CheckBox 
                        name='legends'
                        id='legends'
                        label='Legends'
                        toggle={true}
                        disabled={false}
                        reverse={true}
                        defaultChecked={true}
                        onChange={this._onChange.bind(this, 'legends')}
                        />
                             </Box>
                    
            
            </Box> 
            <Button label='Submit'
                type='submit'
                primary={true}
                onClick={this._onClick.bind(this, output)} />
            </div>
                 
        );
    }
}

export default BarSample;




// WEBPACK FOOTER //
// ./src/samples/options/bar.js